import React, { useReducer, useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AiFillDelete, AiFillEdit } from "react-icons/ai";
// import HeaderImage from "../../../assets/Image/Slider11.jpg";
import MainFooter from "../../../components/mainfooter/MainFooter";
import BackgroundImageLightRight from "../../../assets/Image/BackgroundImageLightRight.png";
import { removeTocart } from "../../../redux/slices/cartSlice";
import {
  fetchCartSingleProducts,
  fetchCartCustomizedProducts,
  fetchCartDotProducts,
  fetchCartCustomizedComboProducts,
  deleteFromCart,
  cartProductMoveToWishlist,
  newCartSiliceAction,
  fetchInvoiceNumber,
  fetchCartDetailsByInvoiceNo,
} from "../../../redux/slices/newCartSlice";
import Modal from "../../../components/modal/Modal";
import Modals from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Select from "react-select";
import {
  numberToWords,
  formatAmount,
  generateInvoiceNumber,
} from "../../../utils/usefullFunction";
import AddClient from "../addClient/AddClient";

// import { fetchWishlistForProductList } from "../../../redux/slices/newWishlistSlice";

// import headerImage from "../../../assets/Image/Slider11.jpg";

import "./styles.css";
import MainHeader from "../../../components/mainheader/MainHeaderNew";
import StickySidebar from "../../../components/stickysidebar/StickySidebar";
import { FinialAmount } from "../../../utils/usefullFunction";
import { getPriceForWishlist } from "../../../utils/varientimge/getPrice";
import { FcInfo } from "react-icons/fc";

import { useLocation, useNavigate } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import {
  setCartCheckoutItem,
  setCartCheckoutProductPrice,
} from "../../../redux/slices/cartSlice";

import { Box } from "@mui/material";
import SnackbarMessage from "../../../utils/snakbar/SnackbarMessage";
import SingleProductCard from "./SingleProductCard";
import CustomizeProductCard from "./CustomizeProductCard";
import SingleDotProductCard from "./SingleDotProductCard";
import CustomizeDotProductCard from "./CustomizeDotProductCard";
import CustomizedCombinationCard from "./CustomizedCombinationCard";
// import ProductCustomizedProduct from "../../pages/client/productdetails/customizedproduct/ProductCustomizedProduct";

import { Slide, Fade } from "@mui/material";
import { axiosInstance, REACT_APP_URL } from "../../../config";
import { toastError, toastSuceess } from "../../../utils/reactToastify";

import Animations from "../../../utils/Skeleton/Animation";
import { IoIosSettings } from "react-icons/io";

function SlideTransition(props) {
  return (
    <Slide {...props} direction="up" vertical="bottom" horizontal="center" />
  );
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 3,
  borderRadius: "5px",
};

const filterProductPrice = (pricesObject, isLoggedIn) => {
  const mongoObjectIdPattern = /^[a-f\d]{24}$/i;

  if (pricesObject && Object.keys(pricesObject).length === 0) {
    return {};
  }

  return Object.fromEntries(
    Object.entries(pricesObject).filter(([key]) =>
      isLoggedIn
        ? mongoObjectIdPattern.test(key)
        : !mongoObjectIdPattern.test(key)
    )
  );
};

const initialState = {
  cartSingleProducts: [],
  customizeProducts: [],
  dotProducts: [],
  cartDotProducts: [],
  customizedComboProducts: [],
  totalPrice: 0,
  totalProductPrice: 0,
  cartDetails: null,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "SET_CART_SINGLE_PRODUCT":
      return { ...state, cartSingleProducts: action.payload };
    case "SET_CART_CUSTOMIZE_PRODUCT":
      return { ...state, customizeProducts: action.payload };
    case "SET_CART_DOT_PRODUCT":
      return { ...state, dotProducts: action.payload };
    case "SET_CART_PRODUCT":
      return { ...state, cartDotProducts: action.payload };
    case "SET_CART_CUSTOMIZED_COMBO_PRODUCT":
      return { ...state, customizedComboProducts: action.payload };
    case "SET_TOTAL_PRICE":
      return { ...state, totalPrice: action.payload };
    case "SET_PRODUCT_TOTAL_AMOUNT":
      return { ...state, totalProductPrice: action.payload };
    case "CART_DETAILS":
      return { ...state, cartDetails: action.payload };
    case "DELETE_CART_PRODUCT":
      const { id, productType } = action.payload;
      return {
        ...state,
        [productType]: state[productType].filter((item) => item?._id !== id),
      };
    default:
      return state;
  }
};

const calculateCustomizedPrice = (
  productDetails,
  combinations,
  priceFor,
  { width, height }
) => {
  if (productDetails && combinations?.length > 0) {
    // const { DefaultWidth, DefaultHeight } = productDetails || {};

    const totalCustomizedPrice =
      productDetails[priceFor] +
      getPriceForWishlist(productDetails, combinations, {
        DefaultWidth: width,
        DefaultHeight: height,
      });

    return totalCustomizedPrice;
  }
  return 0;
};

const initialDiscountState = {
  productDiscount: false,
  Info: false,
  client: false,
};
const initialInstallments = [
  { Name: "Before Production", Amount: 50, Percent: "" },
  { Name: "Before Dispatch", Amount: 50, Percent: "" },
];

const today = new Date();
const formattedDate = `${today.getDate().toString().padStart(2, "0")}/${(
  today.getMonth() + 1
)
  .toString()
  .padStart(2, "0")}/${today.getFullYear()}`;

const Cart = () => {
  const dispatch = useDispatch();

  const { checkoutItem, productPrice: updatedPrice } = useSelector(
    (state) => state.cart
  );
  const { updateSingleProductPrice, updateCustomizeProductPrice } =
    newCartSiliceAction;

  //changes
  const [state, dispatchState] = useReducer(reducer, initialState);
  const { cartdata } = useSelector((state) => state.cart);
  const [productPrice, setProductPrice] = useState({});
  const [productUnitPrice, setProductUnitPrice] = useState({});
  const [productForModal, setProductForModal] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [addressModalOpen, setAddressModalOpen] = useState(false);
  const [modalAddressList, setModalAddressList] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedAddresses, setSelectedAddresses] = useState({
    billTo: null,
    shipTo: null,
  });

  // const [percent, setPercent] = useState(0);
  const handleOpen = () => {
    setModalOpen(true);
  };

  const handleClose = () => setModalOpen(false);

  //changes
  const [discountPrice, setDiscountPrice] = useState("");
  const [installation, setInstallation] = useState("");
  const [transport, setTransport] = useState("");
  const [discount, setDiscount] = useState("");
  const [options, setOptions] = useState([]);
  const [discountInputs, setDiscountInputs] = useState({});
  const [addressType, setAddressType] = useState("");
  const [discountData, setDiscountData] = useState({
    installation: "",
    transport: "",
    discount: "",
  });
  const [note, setNote] = useState("");
  const [selectedFiles, setSelectedFiles] = useState(null);
  const [showBookingModal, setShowBookingModal] = useState(false);
  const [bookingAmt, setBookingAmt] = useState("");
  const [finalBookingAmt, setFinalBookingAmt] = useState(0);

  const openAddressModal = (type) => {
    setAddressType(type); // "billTo" or "shipTo"
    setAddressModalOpen(true);
    setModalAddressList(selectedOption?.fulldata?.Address || []);
  };

  const [invoiceNo, setInvoiceNo] = useState("");
  const [handleEdit, sethandleEdit] = useState(false);
  const [editindex, seteditIndex] = useState(0);
  const [installment, setinstallment] = useState(initialInstallments);
  const [finalInstallment, setFinalInstallment] = useState(initialInstallments);
  const [installmentformdata, setinstallmentformdata] = useState({
    Name: "",
    Amount: "",
  });

  const handleInstallmentformData = (e) => {
    setinstallmentformdata({
      ...installmentformdata,
      [e.target.name]: e.target.value,
    });
  };

  const { Name, Amount } = installmentformdata || {};

  const handleEditInstallment = () => {
    // Create a copy and simulate the edited installment
    const editedInstallments = [...installment];
    editedInstallments.splice(editindex, 1, installmentformdata);

    const Total = editedInstallments.reduce(
      (sum, a) => sum + Number(a.Amount),
      0
    );

    if (Total > 100) {
      return toastError(`Not be Greater than 100%`);
    }

    // Update the actual state
    setinstallment(editedInstallments);

    setinstallmentformdata({
      Name: "",
      Amount: "",
    });
    sethandleEdit(false);
  };

  // console.log("installment", installment);

  const handleInstallment = () => {
    const { Name, Amount } = installmentformdata;

    if (!Name || !Amount) {
      return toastError(`All fields are required!`);
    }

    const Total =
      installment.reduce((sum, a) => sum + Number(a.Amount), 0) +
      Number(Amount);
    if (Total > 100) {
      return toastError(`Not be Greater than 100%`);
    }

    setinstallment((previnstallment) => [
      ...previnstallment,
      installmentformdata,
    ]);
    setinstallmentformdata({
      Name: "",
      Amount: "",
      // Percent: "",
    });
  };

  const handleSaveInstallement = () => {
    let currentInstallments = [...installment];

    // If in edit mode, apply the edit before validation
    if (handleEdit) {
      currentInstallments.splice(editindex, 1, installmentformdata);
    }

    const totalInstallementSum = currentInstallments.reduce(
      (sum, a) => sum + Number(a.Amount),
      0
    );
    // console.log("total", totalInstallementSum)
    if (installment?.length > 0) {
      if (totalInstallementSum !== 100) {
        toastError(`Total must be 100%`);
        return; // Stop further execution
      }
    }

    // Only if validation passes, update final installment and close modal
    setFinalInstallment([...installment]);
    setModalOpen(false);
  };

  const {
    singleProduct,
    singleProductLoading,
    customizeProduct,
    customizeProductLoading,
    dotProduct,
    cartDotProduct,
    dotProductLoading,
    customizedComboProduct,
    customizedComboProductLoading,
    invoiceNumber,
    cartDetailsForInvoiceLoading,
    cartDetailsForInvoice,
  } = useSelector((state) => state.newCartSlice);

  const { userdetails } = useSelector((state) => state.auth);

  const navigate = useNavigate();
  const location = useLocation();
  const {
    cartSingleProducts,
    totalPrice,
    customizeProducts,
    dotProducts,
    customizedComboProducts,
    totalProductPrice,
  } = state;

  const [message, setMessage] = React.useState({
    open: false,
    Transition: Fade,
    type: "",
    message: "",
  });
  const [discountModal, setDiscountModal] = useState(initialDiscountState);
  const [headerImage, setHeaderImage] = useState({});
  const [invoiceLoading, setInvoiceLoading] = useState(false);

  const fetchRootCollection = useCallback(async () => {
    try {
      const { data } = await axiosInstance.get(`/api/header-image/title/cart`);
      if (data?.success) {
        setHeaderImage(data?.data);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toastError(error?.response?.data?.message);
      } else {
        toastError(error?.message);
      }
    }
  }, []);
  useEffect(() => {
    fetchRootCollection();
  }, [fetchRootCollection]);

  useEffect(() => {
    if (invoiceNo) {
      dispatch(fetchCartDetailsByInvoiceNo({ invoiceNo }));
    }
  }, [invoiceNo, dispatch]);

  useEffect(() => {
    const isEmptyUserDetails =
      !userdetails || Object.keys(userdetails).length === 0;

    const userId = isEmptyUserDetails ? "unauthenticated" : userdetails._id;

    setProductPrice({});
    setProductUnitPrice({});
    Promise.all([
      dispatch(fetchInvoiceNumber()),
      dispatch(
        fetchCartSingleProducts({
          product: isEmptyUserDetails ? cartdata : [],
          userId,
          clientId: selectedOption?.fulldata?._id ?? "",
        })
      ),
      dispatch(
        fetchCartCustomizedProducts({
          product: isEmptyUserDetails ? cartdata : [],
          userId,
          clientId: selectedOption?.fulldata?._id ?? "",
        })
      ),
      dispatch(
        fetchCartDotProducts({
          product: isEmptyUserDetails ? cartdata : [],
          userId,
          clientId: selectedOption?.fulldata?._id ?? "",
        })
      ),
      dispatch(
        fetchCartCustomizedComboProducts({
          product: isEmptyUserDetails ? cartdata : [],
          userId,
          clientId: selectedOption?.fulldata?._id ?? "",
        })
      ),
    ]);
  }, [dispatch, userdetails, cartdata, selectedOption]);

  // cart  details for client

  useEffect(() => {
    if (cartDetailsForInvoiceLoading === "fulfilled" && cartDetailsForInvoice) {
      if (selectedOption && cartDetailsForInvoice) {
        const addresses = selectedOption?.fulldata?.Address || [];

        const billTo = addresses.find(
          (addr) => String(addr._id) === String(cartDetailsForInvoice?.billTo)
        );

        const shipTo = addresses.find(
          (addr) => String(addr._id) === String(cartDetailsForInvoice?.shipTo)
        );

        setSelectedAddresses({
          billTo: billTo || addresses[0] || null,
          shipTo: shipTo || addresses[0] || null,
        });
      }

      setInstallation(cartDetailsForInvoice?.installationCharge);
      setTransport(cartDetailsForInvoice?.transportCharge);
      setDiscount(cartDetailsForInvoice?.discount);
      setDiscountData({
        installation: cartDetailsForInvoice?.installationCharge,
        transport: cartDetailsForInvoice?.transportCharge,
        discount: cartDetailsForInvoice?.discount,
      });
      setBookingAmt(cartDetailsForInvoice?.bookingAmount);
      setFinalBookingAmt(cartDetailsForInvoice?.bookingAmount);

      setinstallment(cartDetailsForInvoice?.Installment);
      setFinalInstallment(cartDetailsForInvoice?.Installment);
      setNote(cartDetailsForInvoice?.notes ?? "");
      dispatchState({
        type: "CART_DETAILS",
        payload: cartDetailsForInvoice,
      });
    }
  }, [cartDetailsForInvoice, cartDetailsForInvoiceLoading, selectedOption]);

  // single product
  useEffect(() => {
    if (singleProductLoading === "fulfilled" && singleProduct) {
      dispatchState({
        type: "SET_CART_SINGLE_PRODUCT",
        payload: singleProduct,
      });
    }
  }, [singleProductLoading, singleProduct]);

  // customize product
  useEffect(() => {
    if (customizeProductLoading === "fulfilled" && customizeProduct) {
      dispatchState({
        type: "SET_CART_CUSTOMIZE_PRODUCT",
        payload: customizeProduct,
      });
    }
  }, [customizeProductLoading, customizeProduct]);

  // dot product
  useEffect(() => {
    if (dotProductLoading === "fulfilled" && dotProduct && cartDotProduct) {
      dispatchState({
        type: "SET_CART_DOT_PRODUCT",
        payload: dotProduct,
      });
      dispatchState({
        type: "SET_CART_PRODUCT",
        payload: cartDotProduct,
      });
    }
  }, [dotProductLoading, dotProduct, cartDotProduct]);

  // customized Combo product
  useEffect(() => {
    if (
      customizedComboProductLoading === "fulfilled" &&
      customizedComboProduct
    ) {
      dispatchState({
        type: "SET_CART_CUSTOMIZED_COMBO_PRODUCT",
        payload: customizedComboProduct,
      });
    }
  }, [customizedComboProduct, customizedComboProductLoading]);

  const handleeditInstallment = (index) => {
    sethandleEdit(true);
    const filteredInstallment = installment[index];
    setinstallmentformdata(filteredInstallment);
    seteditIndex(index);
  };

  const handledeleteInstallment = (index) => {
    setinstallment((previnstallment) => {
      const prevInstallment = [...previnstallment];
      prevInstallment.splice(index, 1);
      return prevInstallment;
    });
  };

  const hasProducts =
    (cartSingleProducts && cartSingleProducts.length > 0) ||
    (customizeProducts && customizeProducts.length > 0) ||
    (dotProducts && dotProducts.length > 0) ||
    (customizedComboProducts && customizedComboProducts.length > 0);

  useEffect(() => {
    if (hasProducts) {
      const productArr = [];

      for (let singleProduct of cartSingleProducts) {
        productArr.push({
          _id: singleProduct?._id,
          name: singleProduct?.singleProductId?.ProductName,
          quantity: singleProduct?.quantity,
          product: singleProduct,
          SKU: singleProduct?.SKU ?? "",
        });
      }

      if (
        cartSingleProducts &&
        cartSingleProducts.length > 0 &&
        cartSingleProducts[0]?.invoiceNo
      ) {
        setInvoiceNo(cartSingleProducts[0]?.invoiceNo);
      }

      for (let cusProduct of customizeProducts) {
        productArr.push({
          _id: cusProduct?._id,
          name: cusProduct?.customizeProduct?.ProductName,
          quantity: cusProduct?.quantity,
          product: cusProduct,
        });
      }

      if (
        customizeProducts &&
        customizeProducts.length > 0 &&
        customizeProducts[0]?.invoiceNo
      ) {
        setInvoiceNo(customizeProducts[0]?.invoiceNo);
      }

      for (let dotProduct of dotProducts) {
        productArr.push({
          _id: dotProduct?._id,
          name: dotProduct?.name,
          quantity: dotProduct?.quantity,
          product: dotProduct,
        });
      }

      if (dotProducts && dotProducts.length > 0 && dotProducts[0]?.invoiceNo) {
        setInvoiceNo(dotProducts[0]?.invoiceNo);
      }

      for (let cusComboProduct of customizedComboProducts) {
        productArr.push({
          _id: cusComboProduct?._id,
          name: cusComboProduct?.customizedComboId?.Name,
          quantity: cusComboProduct?.quantity,
          product: cusComboProduct,
        });
      }

      if (
        customizedComboProducts &&
        customizedComboProducts.length > 0 &&
        customizedComboProducts[0]?.invoiceNo
      ) {
        setInvoiceNo(customizedComboProducts[0]?.invoiceNo);
      }

      // setProductPrice({});
      dispatch(setCartCheckoutItem(productArr));
    }
  }, [
    dispatch,
    cartSingleProducts,
    customizeProducts,
    dotProducts,
    customizedComboProducts,
    hasProducts,
  ]);

  useEffect(() => {
    let total = 0;

    const isUserDetails = userdetails && Object.keys(userdetails).length > 0;

    const filteredProductPrice = filterProductPrice(
      productPrice,
      isUserDetails
    );

    dispatch(setCartCheckoutProductPrice(filteredProductPrice));

    for (let key in filteredProductPrice) {
      total += productPrice[key];
    }

    dispatchState({
      type: "SET_TOTAL_PRICE",
      payload: total,
    });

    dispatchState({
      type: "SET_PRODUCT_TOTAL_AMOUNT",
      payload: total,
    });
  }, [dispatch, productPrice, userdetails]);

  const handleMoveToWishlist = (id, productType) => {
    Promise.all([
      dispatch(cartProductMoveToWishlist(id)),
      // dispatch(fetchWishlistForProductList()),
    ]);
    setProductPrice((prevState) => {
      const newState = { ...prevState };
      delete newState[id];
      return newState;
    });
    setProductUnitPrice((prevState) => {
      const newState = { ...prevState };
      delete newState[id];
      return newState;
    });

    dispatchState({
      type: "DELETE_CART_PRODUCT",
      payload: { id, productType },
    });

    setMessage({
      open: true,
      Transition: SlideTransition,
      type: "success",
      message: "Moved to wishlist!",
    });
  };

  const handleDeleteCartItem = (id, productType) => {
    if (userdetails && Object.keys(userdetails).length > 0) {
      dispatch(deleteFromCart(id));
    }

    if (userdetails && Object.keys(userdetails).length === 0) {
      dispatch(removeTocart(id));
    }

    setProductPrice((prevState) => {
      const newState = { ...prevState };
      delete newState[id];
      return newState;
    });
    setProductUnitPrice((prevState) => {
      const newState = { ...prevState };
      delete newState[id];
      return newState;
    });
    dispatchState({
      type: "DELETE_CART_PRODUCT",
      payload: { id, productType },
    });

    setMessage({
      open: true,
      Transition: SlideTransition,
      type: "success",
      message: "Deleted From Cart!",
    });
  };

  const handlelogin = () => {
    sessionStorage.setItem("previousPage", location.pathname);
    navigate("/login");
  };

  useEffect(() => {
    if (productForModal) {
      setDiscountModal((prev) => ({ ...prev, productDiscount: true }));
      setDiscountPrice(productForModal?.currentDiscount);
    }
  }, [productForModal]);

  let totalAmount =
    totalPrice +
    ((parseFloat(installation) || 0) +
      (parseFloat(transport) || 0) -
      (parseFloat(discount) || 0));

  const handleDiscount = () => {
    setDiscountData({
      installation: installation,
      transport: transport,
      discount: discount,
    });
    dispatchState({
      type: "SET_TOTAL_PRICE",
      payload: totalAmount,
    });
    setDiscountModal(initialDiscountState);
    setProductForModal(null);
  };

  const onDiscountClick = (productData) => {
    setProductForModal(productData);
  };

  const onDiscountClose = () => {
    setDiscountModal(initialDiscountState);
    setProductForModal(null);
    setInstallation("");
    setTransport("");
    setDiscount("");
  };

  const handleDiscountSubmit = async (e) => {
    e.preventDefault();

    try {
      const { data } = await axiosInstance.put(
        `/api/cart/updateProductPrice/${productForModal?._id}`,
        {
          newPrice: Number(discountPrice),
        }
      );

      if (data?.success) {
        if (productForModal?.type === "singleProduct") {
          dispatch(
            updateSingleProductPrice({
              productId: productForModal._id,
              newPrice: Number(discountPrice),
            })
          );
        } else if (productForModal?.type === "customizeProduct") {
          dispatch(
            updateCustomizeProductPrice({
              productId: productForModal._id,
              newPrice: Number(discountPrice),
            })
          );
        }

        onDiscountClose();
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const totalInstallmentSum = installment.reduce((sum, p) => {
    return sum + (totalPrice - finalBookingAmt) * (p.Amount / 100);
  }, 0);

  const fetchOptions = async (e) => {
    try {
      const response = await axiosInstance.get(
        `/api/user/getusersdetailsofid`,
        {
          headers: {
            token: localStorage.getItem("token"),
          },
        }
      );
      const formattedOptions = response.data.data.map((item) => ({
        label: item.Name,
        value: item._id,
        address: item.Address[0]?.City || "",
        phone: item.MobNumber,
        fulldata: item,
      }));
      // console.log("Formatted", formattedOptions)
      setOptions(formattedOptions);
      // setAddress()
    } catch (error) {
      console.error("Error fetching user ", error);
    }
  };

  const handleSelectChange = (option) => {
    setSelectedOption(option);
    // Set default addresses as first one
    const defaultAddress = option.fulldata?.Address?.[0] || null;

    setSelectedAddresses({
      billTo: defaultAddress,
      shipTo: defaultAddress,
    });
    setInvoiceNo("");
  };

  const handleInvoice = async () => {
    try {
      setInvoiceLoading(true);
      const response = await axiosInstance.post(
        `/api/pdf/invoice`,
        {
          // checkoutItem,
          cartSingleProducts,
          customizeProducts,
          dotProducts,
          customizedComboProducts,
          updatedPrice,
          productUnitPrice,
          subtotal: totalProductPrice,
          invoiceNo: invoiceNo
            ? invoiceNo
            : generateInvoiceNumber(invoiceNumber),
          installation,
          transport,
          discount,
          finalInstallment,
          finalBookingAmt,
          note,
          formattedDate,
          totalPrice,
          client: selectedOption?.fulldata || null,
          billTo: selectedAddresses?.billTo || null,
          shipTo: selectedAddresses?.shipTo || null,
          Name: userdetails?.Name || "",
          MobNumber: userdetails?.MobNumber || "",
          Email: userdetails?.Email || "",
        },
        {
          responseType: "blob",
        }
      );

      const pdfBlob = new Blob([response.data], {
        type: "application/pdf",
      });

      const a = document.createElement("a");
      const pdfUrl = window.URL.createObjectURL(pdfBlob);
      a.href = pdfUrl;
      a.download = "Invoice";
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(pdfUrl);
      setInvoiceLoading(false);
    } catch (error) {
      setInvoiceLoading(false);
      console.log("error", error);
    }
  };

  const handleNote = (e) => {
    let value = e.target.value;
    const lines = value.split("\n");

    if (lines.length > 10) {
      value = lines.slice(0, 10).join("\n");
    }

    setNote(value);
  };

  const handleFileChange = (e) => {
    setSelectedFiles(e.target.files); // You get a FileList here
  };

  // useEffect(() => {
  //   if (selectedFiles) {
  //     for (let file of selectedFiles) {
  //       console.log("Selected file:", file.name);
  //     }
  //   }
  // }, [selectedFiles]);

  const handleIconClick = () => {
    setDiscountPrice(productForModal.salePrice);
  };

  async function handleSaveForLater() {
    try {
      if (!selectedOption) {
        return toastError("Please select a client first!");
      }

      const cartData = new FormData();

      // Append files
      for (let i = 0; i < selectedFiles?.length; i++) {
        cartData.append("ordersImage", selectedFiles[i]);
      }

      // Append form fields
      cartData.append("details", cartDetailsForInvoice?._id ?? "");
      cartData.append(
        "invoiceNo",
        invoiceNo ? invoiceNo : generateInvoiceNumber(invoiceNumber)
      );
      cartData.append("installationCharge", installation || 0);
      cartData.append("transportCharge", transport || 0);
      cartData.append("discount", discount || 0);
      cartData.append("Installment", JSON.stringify(finalInstallment || []));
      cartData.append("bookingAmount", finalBookingAmt || 0);
      cartData.append("notes", note || "");
      cartData.append("billTo", selectedAddresses?.billTo?._id || "");
      cartData.append("shipTo", selectedAddresses?.shipTo?._id || "");

      const { data } = await axiosInstance.put(
        `/api/cart/transfer-cart/${selectedOption.fulldata?._id}`,
        cartData,
        {
          headers: {
            token: localStorage.getItem("token"),
          },
        }
      );

      if (data?.success) {
        toastSuceess(data.message);
      }
    } catch (error) {
      console.error("Error saving cart:", error);
      toastError("Failed to save cart!");
    }
  }

  return (
    <>
      {productForModal && (
        <Modal
          width="35%"
          handleClose={onDiscountClose}
          show={discountModal.productDiscount}
        >
          <div className="p-5 mb-3">
            <h5 className="mb-1">{productForModal?.productName}</h5>
            <p className="text-muted mb-4">
              Price: <strong>{productForModal?.amount}</strong>
            </p>
            <form onSubmit={handleDiscountSubmit}>
              <div className="mb-2">
                <label required htmlFor="name" className="form-label">
                  Name:
                </label>
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  id="name"
                  required
                  placeholder="Approved by"
                  // value={approvedName}
                  // onChange={(e) => setApprovedName(e.target.value)}
                  value={discountInputs[productForModal._id]?.approvedBy || ""}
                  onChange={(e) =>
                    setDiscountInputs((prev) => ({
                      ...prev,
                      [productForModal._id]: {
                        ...prev[productForModal._id],
                        approvedBy: e.target.value,
                      },
                    }))
                  }
                  style={{ border: "1px solid black" }}
                />
              </div>
              <div className="mb-2">
                <label htmlFor="discountid" className="form-label">
                  Discounted Amount:
                </label>
                <div className="input-group">
                  <input
                    type="text"
                    name="discountId"
                    className="form-control"
                    id="discountId"
                    value={discountPrice}
                    onChange={(e) => setDiscountPrice(e.target.value)}
                    placeholder="Enter discount amount"
                    style={{ border: "1px solid black" }}
                  />

                  <button
                    className="btn btn-outline-secondary"
                    type="button"
                    onClick={handleIconClick}
                  >
                    <IoIosSettings />
                  </button>
                </div>
              </div>

              <div className="gap-2 d-flex justify-content-between">
                <button className="btn btn-success w-50 text-white">
                  Apply
                </button>
                <button
                  className="btn btn-danger w-50 text-white"
                  onClick={onDiscountClose}
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </Modal>
      )}

      {selectedOption && selectedOption?.fulldata && (
        <Modal
          width="90%"
          handleClose={onDiscountClose}
          show={discountModal.client}
        >
          <AddClient showHeader={false} clientData={selectedOption?.fulldata} />
        </Modal>
      )}

      <Modal
        width="35%"
        handleClose={() => setShowBookingModal(false)}
        show={showBookingModal}
      >
        <div className="p-5 mb-3">
          <h5 className="mb-1">Enter Booking Amount</h5>
          <p className="text-muted mb-4">
            Total Price: <strong>₹{formatAmount(totalPrice)}</strong>
          </p>

          <form
            onSubmit={(e) => {
              e.preventDefault();
              const amount = parseFloat(bookingAmt);
              if (isNaN(amount) || amount > totalPrice) {
                alert(
                  "Please enter a valid booking amount less than or equal to total price."
                );
                return;
              }

              setFinalBookingAmt(amount);
              setShowBookingModal(false);
              // setBookingAmt(""); // Clear input
            }}
          >
            <div className="mb-2">
              <label htmlFor="bookingAmt" className="form-label">
                Booking amount:
              </label>
              <input
                type="number"
                name="bookingAmt"
                className="form-control"
                id="bookingAmt"
                placeholder="Enter booking amount"
                value={bookingAmt}
                onChange={(e) => setBookingAmt(e.target.value)}
                style={{ border: "1px solid black" }}
                min={0}
                max={totalPrice}
              />
            </div>

            <div className="gap-2 d-flex justify-content-between">
              <button type="submit" className="btn btn-success w-50 text-white">
                Apply
              </button>
              <button
                type="button"
                className="btn btn-danger w-50 text-white"
                onClick={() => {
                  setShowBookingModal(false);
                  // setBookingAmt("");
                }}
              >
                Close
              </button>
            </div>
          </form>
        </div>
      </Modal>

      <Modal
        show={discountModal?.Info}
        handleClose={onDiscountClose}
        width="35%"
      >
        <div className="p-5 mb-3">
          <h5 className="mb-1">Total Amount</h5>
          <p className="text-muted mb-4">
            Price: <strong>₹{totalPrice.toLocaleString()}</strong>
          </p>
          <div className="row">
            <div className="col-md-6">
              <label htmlFor="Installation_Charge" className="form-label">
                Installation Charge :
              </label>
              <input
                type="text"
                className="form-control mb-2"
                value={installation}
                onChange={(e) => setInstallation(e.target.value)}
                id="Installation_Charge"
                style={{ border: "1px solid black" }}
              />
            </div>
            <div className="col-md-6">
              <label htmlFor="Transportation_Charge" className="form-label">
                Transport Charge :
              </label>
              <input
                type="text"
                className="form-control mb-2"
                id="Transport_Charge"
                value={transport}
                onChange={(e) => setTransport(e.target.value)}
                style={{ border: "1px solid black" }}
              />
            </div>
          </div>

          <div className="mb-4">
            <label htmlFor="discountid2" className="form-label">
              Discount :
            </label>
            <input
              type="text"
              className="form-control"
              id="discountid2"
              value={discount}
              onChange={(e) => setDiscount(e.target.value)}
              placeholder="Enter discount amount"
              style={{ border: "1px solid black" }}
            />
          </div>

          <label className="form-label">Total Amount :</label>
          <input
            type="text"
            className="form-control mb-4"
            placeholder="Total Amount"
            value={totalAmount.toLocaleString()}
            readOnly
            style={{ border: "1px solid black" }}
          />

          <div className="gap-2 d-flex justify-content-between">
            <button
              className="btn btn-success w-50 text-white"
              onClick={handleDiscount}
            >
              Apply
            </button>
            <button
              className="btn btn-danger w-50 text-white"
              onClick={onDiscountClose}
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>

      <Modals
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={modalOpen}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={modalOpen}>
          <Box sx={style}>
            <div className="row mb-3">
              <div className="border mt-3">
                <h6
                  className="mt-2"
                  style={{
                    backgroundColor: "#2D1967",
                    padding: "15px",
                    color: "#fff",
                  }}
                >
                  Installment Distribution Section
                </h6>
                <div
                  className="label d-flex justify-content-between"
                  style={{ fontWeight: "600", fontSize: "20px" }}
                >
                  Total Amount
                  <div>₹{formatAmount(totalPrice - finalBookingAmt)}</div>
                </div>
                <div className="row my-3 ">
                  <div className="col-md-4">
                    {" "}
                    <label className="form-label" htmlFor="Shipping">
                      Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="Shipping"
                      name="Name"
                      value={Name}
                      onChange={handleInstallmentformData}
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label" htmlFor="Shipping">
                      Percentage
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="Shipping"
                      name="Amount"
                      value={Amount}
                      onChange={handleInstallmentformData}
                    />
                  </div>
                  <div className="col-md-4  mt-4">
                    {handleEdit ? (
                      <button
                        className=" btn btn-primary mt-1"
                        type="button"
                        onClick={handleEditInstallment}
                      >
                        Edit Installment
                      </button>
                    ) : (
                      <button
                        className=" btn btn-primary mt-1"
                        type="button"
                        onClick={handleInstallment}
                      >
                        Add Installment
                      </button>
                    )}
                  </div>
                </div>

                <table className="table">
                  <tbody>
                    {installment &&
                      Object.keys(installment).length > 0 &&
                      installment.map((p, i) => (
                        <tr key={i}>
                          <td className="col-md-2">
                            <h5>
                              <>{i + 1}</>
                            </h5>
                          </td>
                          <td className="col-md-4">
                            <>{p.Name}</>
                          </td>
                          <td className="col-md-4">
                            <>{p.Amount}%</>
                          </td>
                          <td className="col-md-4">
                            <>
                              {formatAmount(
                                (
                                  (totalPrice - finalBookingAmt) *
                                  (p.Amount / 100)
                                ).toFixed(0)
                              )}
                            </>
                          </td>
                          <td className="col-md-2 ">
                            <div className="d-inline-flex">
                              <span
                                className="bg-success p-1 rounded"
                                onClick={() => handleeditInstallment(i)}
                              >
                                <AiFillEdit />
                              </span>
                              &nbsp;
                              <span
                                className="bg-danger p-1 rounded"
                                onClick={() => handledeleteInstallment(i)}
                              >
                                <AiFillDelete />
                              </span>
                            </div>
                          </td>
                        </tr>
                      ))}
                    <tr>
                      <td style={{ fontWeight: "800" }}>Total</td>
                      <td></td>
                      <td style={{ fontWeight: "800" }}>
                        {installment.reduce(
                          (sum, a) => sum + Number(a.Amount),
                          0
                        )}
                        %
                      </td>
                      <td>
                        <b>{formatAmount(totalInstallmentSum)}</b>
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div style={{ textAlign: "center" }}>
              <button
                onClick={handleSaveInstallement}
                type="button"
                className="btn btn-primary"
              >
                Save
              </button>
            </div>
          </Box>
        </Fade>
      </Modals>

      <Modal
        show={addressModalOpen}
        handleClose={() => setAddressModalOpen(false)}
      >
        <div className="p-3">
          <h5 className="mb-3">
            Select Address for{" "}
            {addressType === "billTo" ? "Bill To" : "Ship To"}
          </h5>

          {modalAddressList.map((addr, index) => (
            <div
              key={index}
              className="border rounded p-2 mb-2"
              style={{ cursor: "pointer", background: "#f9f9f9" }}
              onClick={() => {
                // Update selected address in state
                setSelectedAddresses((prev) => ({
                  ...prev,
                  [addressType]: addr, // key: billTo or shipTo
                }));
                setAddressModalOpen(false); // Close modal
              }}
            >
              <span>
                <strong>Address:</strong> {addr.Address}{" "}
              </span>
              <span>
                <strong>City:</strong> {addr.City}{" "}
              </span>
              <span>
                <strong>State:</strong> {addr.State}{" "}
              </span>
              <span>
                <strong>Postal Code:</strong> {addr.PostalCode}{" "}
              </span>
              <span>
                <strong>Country:</strong> {addr.Country}{" "}
              </span>
            </div>
          ))}
        </div>
      </Modal>

      <SnackbarMessage setState={setMessage} state={message} />
      <StickySidebar />
      <MainHeader isImageAvailable={headerImage?.pngImage ? true : false} />
      <div
        className="div"
        style={{
          height: headerImage?.pngImage ? "60vh" : "11vh",
          overflow: "hidden",
          position: "relative",
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.5)), url(${REACT_APP_URL}/images/header/${headerImage?.pngImage})`,
          backgroundSize: "cover",
        }}
      ></div>
      <div
        className="row"
        style={{
          backgroundImage: `url(${BackgroundImageLightRight})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          paddingTop: "10px",
        }}
      >
        <div style={{ paddingRight: "50px" }}>
          <div className="d-flex justify-content-end align-items-center">
            <div
              style={{ width: "350px", margin: "10px", marginRight: "10px" }}
            >
              <Select
                options={options}
                value={selectedOption}
                onChange={handleSelectChange}
                isSearchable
                placeholder="Select a client"
                onFocus={fetchOptions}
              />
            </div>
            <div>
              <button
                className="btn btn-success fw-bold"
                onClick={() => navigate("/AddClient")}
              >
                Add Client
              </button>
            </div>
          </div>
        </div>

        <div
          style={{
            width: "93%",
            margin: "0 auto",
            border: "1px dashed #ccc",
            borderRadius: "5px",
          }}
          className="bg-light  p-2 mb-2"
        >
          <div className="d-flex justify-content-around align-items-center">
            <h6 className="mb-0 text-secondary">
              <strong>Invoice No.:</strong>{" "}
              {invoiceNo ? invoiceNo : generateInvoiceNumber(invoiceNumber)}
            </h6>
            <h6 className="mb-0 text-secondary">
              <strong>Invoice Date:</strong> {formattedDate}
            </h6>
          </div>
        </div>
        {selectedOption &&
          selectedAddresses.billTo &&
          selectedAddresses.shipTo && (
            <div
              style={{
                width: "93%",
                marginLeft: "3.4%",
                marginRight: "3.9%",
                border: "1px dashed #ccc",
              }}
              className="d-flex flex-wrap gap-4 justify-content-around bg-light p-3 rounded mb-4"
            >
              {/* BILL TO Card */}
              <div
                className="px-4 py-2 rounded d-flex"
                style={{
                  backgroundColor: "#fff",
                  minWidth: "300px",
                  border: "1px dashed #ccc",
                  width: "43%",
                }}
              >
                {/* <div className="d-flex"> */}
                <div className="d-flex gap-5">
                  <div>
                    <h6 className="text-uppercase fw-bold text-dark mb-1">
                      BILL TO
                    </h6>
                    <p className="text-dark mb-1">{selectedOption.label}</p>
                    <p className="mb-1 text-muted">
                      GSTIN : {selectedOption?.fulldata?.GSTIN}{" "}
                    </p>
                    <p className="mb-1 text-muted">
                      Address: {selectedAddresses?.billTo?.Address}
                    </p>
                    <span className="mb-1 text-muted">
                      Phone: {selectedOption?.phone}{" "}
                    </span>
                    <span className="mb-1 text-muted">
                      State: {selectedAddresses?.billTo?.State}{" "}
                    </span>
                    <span className="mb-1 text-muted">
                      Place of Supply: {selectedAddresses?.billTo?.City}{" "}
                    </span>
                  </div>
                </div>
                <div>
                  <button
                    onClick={() => openAddressModal("billTo")}
                    className="btn btn-dark btn-sm "
                    style={{ fontSize: "0.8rem", padding: "4px 14px" }}
                  >
                    Edit
                  </button>
                </div>
                {/* </div> */}
              </div>
              {/* SHIP TO Card */}
              {/* BILL TO Card */}
              <div
                className="px-4 py-2 rounded d-flex"
                style={{
                  backgroundColor: "#fff",
                  minWidth: "300px",
                  border: "1px dashed #ccc",
                  width: "43%",
                }}
              >
                {/* <div className="d-flex"> */}
                <div className="d-flex gap-5">
                  <div>
                    <h6 className="text-uppercase fw-bold text-dark mb-1">
                      Ship TO
                    </h6>
                    <h5 className="text-dark mb-1">{selectedOption.label}</h5>
                    <p className="mb-1 text-muted">
                      GSTIN : {selectedOption?.fulldata?.GSTIN}{" "}
                    </p>
                    <p className="mb-1 text-muted">
                      Address: {selectedAddresses?.shipTo?.Address}
                    </p>
                    <span className="mb-1 text-muted">
                      Phone: {selectedOption?.phone}{" "}
                    </span>
                    <span className="mb-1 text-muted">
                      State: {selectedAddresses?.shipTo?.State}{" "}
                    </span>
                    <span className="mb-1 text-muted">
                      Place of Supply: {selectedAddresses?.shipTo?.City}{" "}
                    </span>
                  </div>
                </div>
                <div>
                  <button
                    onClick={() => openAddressModal("shipTo")}
                    className="btn btn-dark btn-sm "
                    style={{ fontSize: "0.8rem", padding: "4px 14px" }}
                  >
                    Edit
                  </button>
                </div>
                {/* </div> */}
              </div>

              <div
                onClick={() =>
                  setDiscountModal((prev) => ({ ...prev, client: true }))
                }
                style={{ color: "#5353db", cursor: "pointer" }}
              >
                Click to update client details{" "}
              </div>
            </div>
          )}

        <div className="container" style={{ width: "94%" }}>
          <div className="CartTableStyle">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th
                    style={{
                      textTransform: "uppercase",
                      width: "20%",
                      backgroundColor: "#475B52",
                      color: "#fff",
                    }}
                  >
                    Prepared by
                  </th>
                  <th
                    style={{
                      textTransform: "uppercase",
                      width: "20%",
                      color: "#fff",
                      backgroundColor: "#475B52",
                    }}
                  >
                    Mob. Number
                  </th>
                  <th
                    style={{
                      textTransform: "uppercase",
                      textAlign: "center",
                      width: "20%",
                      color: "#fff",
                      backgroundColor: "#475B52",
                    }}
                  >
                    Email address:
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{userdetails?.Name}</td>
                  <td>{userdetails?.MobNumber}</td>
                  <td>{userdetails?.Email}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        {/* {console.log("userdetails", userdetails)} */}
        {/* <hr style={{ borderTop: "2px solid #000", margin: "20px 0" }} /> */}

        <div className="container" style={{ width: "94%" }}>
          <div className="table-responsive CartTableStyle">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th
                    style={{
                      textTransform: "uppercase",
                      width: "10%",
                      backgroundColor: "#475B52",
                      color: "#fff",
                    }}
                  >
                    Image
                  </th>
                  <th
                    style={{
                      textTransform: "uppercase",
                      width: "40%",
                      color: "#fff",
                      backgroundColor: "#475B52",
                    }}
                  >
                    Product Details
                  </th>
                  <th
                    style={{
                      textTransform: "uppercase",
                      textAlign: "center",
                      width: "10%",
                      color: "#fff",
                      backgroundColor: "#475B52",
                    }}
                  >
                    HSN Code
                  </th>
                  <th
                    style={{
                      textTransform: "uppercase",
                      textAlign: "center",
                      width: "15%",
                      color: "#fff",
                      backgroundColor: "#475B52",
                    }}
                  >
                    Unit Price
                  </th>
                  <th
                    style={{
                      textTransform: "uppercase",
                      textAlign: "center",
                      width: "15%",
                      color: "#fff",
                      backgroundColor: "#475B52",
                    }}
                  >
                    Quantity
                  </th>
                  <th
                    style={{
                      textTransform: "uppercase",
                      textAlign: "right",
                      width: "20%",
                      color: "#fff",
                      backgroundColor: "#475B52",
                    }}
                  >
                    Total Price
                  </th>
                </tr>
              </thead>
              <tbody>
                {singleProductLoading === "pending" ? (
                  <tr>
                    <td colspan="6">
                      <Animations />
                    </td>
                  </tr>
                ) : (
                  <>
                    {cartSingleProducts &&
                      cartSingleProducts?.length > 0 &&
                      cartSingleProducts.map((product, index) => (
                        <SingleProductCard
                          key={index}
                          index={index}
                          product={product}
                          FinialAmount={FinialAmount}
                          setProductPrice={setProductPrice}
                          setProductUnitPrice={setProductUnitPrice}
                          handleDeleteCartItem={handleDeleteCartItem}
                          handleMoveToWishlist={handleMoveToWishlist}
                          userdetails={userdetails}
                          onDiscountClick={onDiscountClick}
                        />
                      ))}
                  </>
                )}

                {customizeProductLoading === "pending" ? (
                  <tr>
                    <td colspan="6">
                      <Animations />
                    </td>
                  </tr>
                ) : (
                  <>
                    {customizeProducts &&
                      customizeProducts?.length > 0 &&
                      customizeProducts.map((product, index) => (
                        <CustomizeProductCard
                          key={product?._id}
                          calculateCustomizedPrice={calculateCustomizedPrice}
                          product={product?.customizeProduct}
                          customizedproductcardheight={"38vh"}
                          combination={product}
                          setProductPrice={setProductPrice}
                          setProductUnitPrice={setProductUnitPrice}
                          handleDeleteCartItem={handleDeleteCartItem}
                          handleMoveToWishlist={handleMoveToWishlist}
                          userdetails={userdetails}
                          onDiscountClick={onDiscountClick}
                        />
                      ))}
                  </>
                )}

                {dotProductLoading === "pending" ? (
                  <tr>
                    <td colspan="6">
                      <Animations />
                    </td>
                  </tr>
                ) : (
                  <>
                    {dotProducts &&
                      dotProducts?.length > 0 &&
                      dotProducts?.map((p, index) =>
                        p?.type === "singleDotProduct" ? (
                          <SingleDotProductCard
                            key={p._id}
                            product={p}
                            setProductPrice={setProductPrice}
                            handleDeleteCartItem={handleDeleteCartItem}
                            FinialAmount={FinialAmount}
                            handleMoveToWishlist={handleMoveToWishlist}
                            userdetails={userdetails}
                            onDiscountClick={onDiscountClick}
                          />
                        ) : (
                          <CustomizeDotProductCard
                            key={p._id}
                            product={p}
                            setProductPrice={setProductPrice}
                            handleDeleteCartItem={handleDeleteCartItem}
                            calculateCustomizedPrice={calculateCustomizedPrice}
                            handleMoveToWishlist={handleMoveToWishlist}
                            userdetails={userdetails}
                            // wishlistData={dotProductWishlist || []}
                            // isProductInWishlist={isCustomizedDotProductInWishlist}
                            onDiscountClick={onDiscountClick}
                          />
                        )
                      )}
                  </>
                )}

                {customizedComboProductLoading === "pending" ? (
                  <tr>
                    <td colspan="6">
                      <Animations />
                    </td>
                  </tr>
                ) : (
                  <>
                    {customizedComboProducts &&
                      customizedComboProducts?.length > 0 &&
                      customizedComboProducts.map((product, index) => (
                        <CustomizedCombinationCard
                          key={product?._id}
                          product={product?.customizedComboId}
                          cartData={product}
                          selectedCustomizedProduct={
                            product?.customizedComboRectangle
                          }
                          setProductPrice={setProductPrice}
                          handleDeleteCartItem={handleDeleteCartItem}
                          handleMoveToWishlist={handleMoveToWishlist}
                          userdetails={userdetails}
                          onDiscountClick={onDiscountClick}
                        />
                      ))}
                  </>
                )}
              </tbody>
            </table>
          </div>
          <>
            <hr style={{ borderTop: "1.5px solid #333", margin: 0 }} />
            <div className="d-flex justify-content-between align-items-center mt-2">
              <h5>
                <b>SUBTOTAL</b>
              </h5>
              <h5>
                <b>₹{formatAmount(totalProductPrice.toFixed(0))}</b>
              </h5>
            </div>
            <hr style={{ borderTop: "1.5px solid #333", margin: 0 }} />
          </>

          <div className="d-flex justify-content-between mt-3">
            <div>
              <h5>
                <b>BANK DETAILS</b>
              </h5>
              <div className="d-flex" style={{ gap: "83px" }}>
                <b>Account Name:</b>
                <b>RAILINGO PRIVATE LIMITED</b>
              </div>
              <div className="d-flex" style={{ gap: "65px" }}>
                <b>Account Number:</b>
                <b>432105001207</b>
              </div>
              <div className="d-flex" style={{ gap: "107px" }}>
                <b>Bank Name:</b>
                <b>ICICI Bank</b>
              </div>
              <div className="d-flex" style={{ gap: "138px" }}>
                <b>Branch:</b>
                <b>Gurgaon</b>
              </div>
              <div className="d-flex" style={{ gap: "112px" }}>
                <b>IFCS Code:</b>
                <b>ICIC0004321</b>
              </div>
              <div className="mt-3">
                <h5>
                  <b>PAYMENT QR CODE</b>
                </h5>
                <div className="d-flex" style={{ gap: "134px" }}>
                  <b>UPI ID : </b>
                  <b>MSRAILINGOPRIVATELIMITED.eazypay@icici</b>
                </div>
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: "20vh" }}
                >
                  <img
                    src="/QRCode.png"
                    style={{ width: "70px" }}
                    alt="Centered"
                  />
                </div>
              </div>
            </div>
            <div className="s-cart-bottom">
              {discountData?.installation &&
                discountData?.installation !== "0" && (
                  <div
                    className="label d-flex justify-content-between"
                    style={{ fontWeight: "600", fontSize: "15px" }}
                  >
                    Installation Charge :
                    <div style={{ fontWeight: "600", fontSize: "15px" }}>
                      ₹{formatAmount(discountData.installation)}
                    </div>
                  </div>
                )}

              {discountData.installation === "0" && (
                <div
                  className="label d-flex justify-content-between"
                  style={{ fontWeight: "600", fontSize: "15px" }}
                >
                  Installation Charge :
                  <div style={{ fontWeight: "600", fontSize: "15px" }}>
                    Free
                  </div>
                </div>
              )}

              {discountData.transport && discountData.transport !== "0" && (
                <div
                  className="label d-flex justify-content-between"
                  style={{ fontWeight: "600", fontSize: "15px" }}
                >
                  Transport Charge :
                  <div style={{ fontWeight: "600", fontSize: "15px" }}>
                    ₹{formatAmount(discountData.transport)}
                  </div>
                </div>
              )}

              {discountData.transport === "0" && (
                <div
                  className="label d-flex justify-content-between"
                  style={{ fontWeight: "600", fontSize: "15px" }}
                >
                  Transport Charge :
                  <div style={{ fontWeight: "600", fontSize: "15px" }}>
                    Free
                  </div>
                </div>
              )}

              {discountData.discount && (
                <div
                  className="label d-flex justify-content-between"
                  style={{ fontWeight: "600", fontSize: "15px" }}
                >
                  Discount :
                  <div style={{ fontWeight: "600", fontSize: "15px" }}>
                    ₹{formatAmount(discountData.discount)}
                  </div>
                </div>
              )}

              <div className="s-cart-row d-flex justify-content-between align-items-center">
                {/* Left: Subtotal Label */}
                <div
                  className="label"
                  style={{ fontWeight: "600", fontSize: "15px" }}
                >
                  Subtotal Amount :
                </div>

                {/* Right: Amount + Info Icon */}
                <div className="d-flex align-items-center gap-2">
                  <div
                    className="price"
                    style={{ fontWeight: "600", fontSize: "15px" }}
                  >
                    ₹{formatAmount(totalPrice)}
                  </div>
                  <FcInfo
                    onClick={() =>
                      setDiscountModal((prev) => ({ ...prev, Info: true }))
                    }
                    size={22}
                    style={{ cursor: "pointer" }}
                  />
                </div>
              </div>

              <div
                className="label d-flex justify-content-between"
                style={{ fontWeight: "600", fontSize: "15px" }}
              >
                Taxable Amount
                <div>{formatAmount(totalPrice - totalPrice * 0.18)}</div>
              </div>
              <div
                className="label d-flex justify-content-between"
                style={{ fontWeight: "600", fontSize: "15px" }}
              >
                CGST @9%
                <div>{formatAmount(totalPrice * 0.09)}</div>
              </div>
              <div
                className="label d-flex justify-content-between"
                style={{ fontWeight: "600", fontSize: "15px" }}
              >
                SGST @9%
                <div>{formatAmount(totalPrice * 0.09)}</div>
              </div>

              <div className="s-cart-row d-flex justify-content-between align-items-center">
                {/* Left Side: Label */}
                <div
                  className="label"
                  style={{ fontWeight: "600", fontSize: "20px" }}
                >
                  Total Amount :
                </div>

                {/* Right Side: Amount + Icon */}
                <div className="d-flex align-items-center gap-2">
                  <div
                    className="price"
                    style={{ fontWeight: "600", fontSize: "15px" }}
                  >
                    ₹{formatAmount(totalPrice)}
                  </div>
                  <FcInfo
                    // onClick={() => setShowBookingModal(true)}
                    onClick={handleOpen}
                    size={22}
                    style={{ cursor: "pointer" }}
                  />
                </div>
              </div>

              {/* Booking summary section - shown below total */}
              {typeof finalBookingAmt === "number" && finalBookingAmt !== 0 && (
                <>
                  <div
                    className="label d-flex justify-content-between"
                    style={{ fontWeight: "600", fontSize: "15px" }}
                  >
                    Booking Amount:
                    <div>₹{formatAmount(finalBookingAmt)}</div>
                  </div>
                  <div
                    className="label d-flex justify-content-between"
                    style={{ fontWeight: "600", fontSize: "15px" }}
                  >
                    Remaining Amount:
                    <div>₹{formatAmount(totalPrice - finalBookingAmt)}</div>
                  </div>
                </>
              )}

              <div style={{ fontSize: "12px" }}>
                ({numberToWords(totalPrice - finalBookingAmt)})
              </div>
              <div
                style={{ borderTop: "1px solid #000", margin: "10px 0" }}
              ></div>
              {/* <button className="btn btn-primary" onClick={handleClick}>Add Installment</button> */}
              <button
                // onClick={handleOpen}
                onClick={() => setShowBookingModal(true)}
                type="button"
                style={{
                  backgroundColor: "#475B52", // green
                  color: "white",
                  padding: "5px 5px",
                  fontSize: "16px",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Deposit Booking Amount
              </button>
            </div>
          </div>

          {
            <table className="table table-hover table-bordered rounded-sm shadow-sm overflow-hidden">
              <thead className="table-success text-center">
                <tr>
                  <th>Payment From</th>
                  {/* {console.log("installment", installment)} */}
                  {finalInstallment.map((item, index) => (
                    <th key={index} className="fw-semibold">
                      {item.Name} ({item.Amount}%)
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="text-center align-middle">
                <tr>
                  <td>
                    <strong>{selectedOption?.label || ""}</strong>
                  </td>
                  {finalInstallment.map((item, index) => (
                    <td key={index}>
                      ₹{" "}
                      {formatAmount(
                        (
                          (totalPrice - finalBookingAmt) *
                          (item.Amount / 100)
                        ).toFixed(0)
                      )}
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          }
          <div className="d-flex gap-3 align-items-start rounded mb-5">
            <div style={{ width: "800px" }}>
              <textarea
                className="form-control"
                placeholder="Add your notes here..."
                onChange={handleNote}
                value={note}
                // style={{
                //   height: "120px",
                //   minHeight: "120px",
                //   resize: "vertical",
                //   maxWidth: "750px",
                // }}
                maxLength={1000}
                style={{
                  height: "120px",
                  width: "100%",
                  resize: "none", // disable manual resizing
                  overflowY: "auto", // scrollbar if too many lines
                  whiteSpace: "pre-wrap", // preserve line breaks and wrap
                  wordBreak: "break-word", // break long words if needed
                }}
              />
              <div
                className="text-end text-muted mt-1"
                style={{ fontSize: "0.875rem" }}
              >
                {note.split("\n").length} / 10 lines | {note.length} / 1000
                characters
              </div>
            </div>

            <div
              className="upload-container"
              style={{
                height: "120px",
                width: "600px",
                padding: "15px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <input
                type="file"
                id="file_upload"
                multiple
                accept="image/*"
                onChange={handleFileChange}
                style={{
                  height: "120px",
                  fontSize: "0.9rem",
                  padding: "12px 12px",
                  width: "100%",
                }}
              />
            </div>
          </div>

          <div style={{ textAlign: "center" }}>
            {hasProducts && (
              <>
                {userdetails && Object.keys(userdetails)?.length > 0 ? (
                  <div className="d-flex gap-2 justify-content-center">
                    <Button
                      onClick={handleInvoice}
                      variant="contained"
                      disabled={invoiceLoading}
                      loading={invoiceLoading}
                      loadingPosition="end"
                      // style={{ backgroundColor: "#4e74f5", color: "#ffffff" }}
                      sx={{
                        width: { xs: "100%", sm: "fit-content" },
                      }}
                    >
                      {invoiceLoading ? "Downloading..." : "Download Invoice"}
                    </Button>
                    <Button
                      onClick={handleSaveForLater}
                      variant="contained"
                      disabled={false}
                      style={{
                        backgroundColor: "#dc6335",
                        color: "#ffffff",
                        marginRight: "5px",
                      }}
                      sx={{
                        width: { xs: "100%", sm: "fit-content" },
                      }}
                    >
                      Save for later
                    </Button>
                    <Button
                      href="/checkout"
                      variant="contained"
                      disabled={false}
                      style={{ backgroundColor: "#475B52", color: "#ffffff" }}
                      sx={{
                        width: { xs: "100%", sm: "fit-content" },
                      }}
                    >
                      Proceed with payment
                    </Button>
                  </div>
                ) : (
                  <Button
                    style={{ backgroundColor: "#475B52", color: "#ffffff" }}
                    onClick={handlelogin}
                  >
                    Login To Checkout Now
                  </Button>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      <br></br>
      <MainFooter />
    </>
  );
};

export default Cart;
